import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

const binstantApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export default binstantApi
